import React from 'react';
import { useIntl } from 'react-intl';

import { Button, Typography } from '@bolteu/clay-react';

export type StoreSelectorHeaderStrings = Record<'yourVenue' | 'addVenue', string>;
export interface StoreSelectorHeaderProps {
  showAddVenueButton: boolean;
  onAddVenue?: () => void;
}
export function StoreSelectorHeader({ onAddVenue, showAddVenueButton }: StoreSelectorHeaderProps) {
  const intl = useIntl();
  const yourVenue = intl.formatMessage({ id: 'venueSelector.header.selectVenue' });
  const addVenue = intl.formatMessage({ id: 'venueSelector.header.addVenue' });

  const handleAddVenue = React.useCallback(() => {
    if (onAddVenue) {
      onAddVenue();
    }
  }, [onAddVenue]);
  return (
    <div className="mb-1 flex items-center justify-between gap-3 py-3">
      <Typography defaultTag="h1" className="m-0 bolt-font-heading-xs-accent text-primary">
        {yourVenue}
      </Typography>
      {showAddVenueButton && (
        <Button variant="secondary" size="sm" onClick={handleAddVenue}>
          {addVenue}
        </Button>
      )}
    </div>
  );
}
